/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions(value) {
    if (!('XsollaEnabled' in value) || value['XsollaEnabled'] === undefined)
        return false;
    if (!('YookassaEnabled' in value) || value['YookassaEnabled'] === undefined)
        return false;
    if (!('StripeEnabled' in value) || value['StripeEnabled'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'XsollaEnabled': json['XsollaEnabled'],
        'YookassaEnabled': json['YookassaEnabled'],
        'StripeEnabled': json['StripeEnabled'],
    };
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'XsollaEnabled': value['XsollaEnabled'],
        'YookassaEnabled': value['YookassaEnabled'],
        'StripeEnabled': value['StripeEnabled'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions.js.map